module.exports = __webpack_public_path__ + "media/configurations/SO-SX-SX-cc4a40cf.png";